/**
 * PDF Studio tool registry (separate from Fabric design editor tools).
 */

export type PdfToolId =
  | 'pointer'
  | 'text'
  | 'highlight'
  | 'brush'
  | 'eraser'
  | 'image'
  | 'shapes'
  | 'sign'
  | 'hand';

export interface PdfToolDef {
  id: PdfToolId;
  label: string;
  /** Short hint for the right options panel */
  hint: string;
  /** Whether the right panel shows tool options */
  hasOptions: boolean;
}

export const PDF_TOOLS: PdfToolDef[] = [
  {
    id: 'pointer',
    label: 'Pointer',
    hint: 'Select, move, and resize annotations. Use this after placing a signature.',
    hasOptions: false,
  },
  { id: 'text', label: 'Add text', hint: 'Click to place a text box.', hasOptions: true },
  { id: 'highlight', label: 'Highlight', hint: 'Drag to highlight an area.', hasOptions: true },
  { id: 'brush', label: 'Brush', hint: 'Freehand draw on the page.', hasOptions: true },
  { id: 'eraser', label: 'Eraser', hint: 'Click an annotation to remove it.', hasOptions: false },
  { id: 'image', label: 'Image', hint: 'Place an image on the page.', hasOptions: false },
  { id: 'shapes', label: 'Shapes', hint: 'Drag to draw a rectangle or ellipse.', hasOptions: true },
  {
    id: 'sign',
    label: 'Sign',
    hint: 'Create or select a signature, then click the page to place it.',
    hasOptions: true,
  },
  { id: 'hand', label: 'Move', hint: 'Pan the document.', hasOptions: false },
];

export type PdfShapeKind = 'rect' | 'ellipse';

export const SIGNATURE_SCRIPT_FONTS = [
  { id: 'caveat', label: 'Caveat', family: '"Caveat", "Segoe Script", cursive' },
  { id: 'pacifico', label: 'Pacifico', family: '"Pacifico", "Brush Script MT", cursive' },
  { id: 'segoe', label: 'Segoe Script', family: '"Segoe Script", "Brush Script MT", cursive' },
  { id: 'brush', label: 'Brush Script', family: '"Brush Script MT", cursive' },
] as const;
